import { Bot, Clock } from "lucide-react";
import { useMemo } from "react";
import "./loaders.css"; // We'll create this file next
import { TypingIndicatorProps } from "../types";

// Define the available loader types
export type LoaderType = "dots" | "ripple";

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  formatTime,
  visible,
  loaderType = "ripple"
}) => {
  // Generate a stable timestamp that won't change on re-renders
  const timestamp = useMemo(() => new Date(), []);

  // Default formatTime function if not provided
  const formatTimeFunc =
    formatTime ||
    ((date: Date) => {
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
    });

  // If not visible, don't render anything
  if (!visible) {
    return null;
  }

  // Render the appropriate loader based on the type
  const renderLoader = () => {
    switch (loaderType) {
      case "ripple":
        return (
          <div className="loader2-container">
            <div className="loader2"></div>
          </div>
        );

      case "dots":
      default:
        return (
          <div className="flex space-x-1">
            <div
              className="w-1.5 h-1.5 rounded-full bg-zinc-400 animate-bounce"
              style={{ animationDelay: "0ms" }}
            ></div>
            <div
              className="w-1.5 h-1.5 rounded-full bg-zinc-400 animate-bounce"
              style={{ animationDelay: "150ms" }}
            ></div>
            <div
              className="w-1.5 h-1.5 rounded-full bg-zinc-400 animate-bounce"
              style={{ animationDelay: "300ms" }}
            ></div>
          </div>
        );
    }
  };

  return (
    <div className="flex justify-start animate-fade-in max-w-full ">
      <div className="bg-zinc-100 rounded-2xl rounded-tl-sm px-3 py-2 sm:px-4 sm:py-3 text-zinc-800 text-sm max-w-[85%] sm:max-w-[75%]">
        <div className="flex flex-col space-y-1 sm:space-y-2">
          <div className="flex items-center mb-1">
            <Bot className="w-3 h-3 mr-1" />
            <span className="text-xs opacity-75">Assistant</span>
            <span className="ml-2 text-xs opacity-75 flex items-center">
              <Clock className="w-2.5 h-2.5 mr-1" />
              {formatTimeFunc(timestamp)}
            </span>
          </div>
          {renderLoader()}
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
